module.exports = __webpack_public_path__ + "static/media/bottomTopRightDark.fe023e2d.svg";